import React, { useState } from "react";
import {
  LinearProgress,
  OutlinedInput,
} from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem,
  TableRow, Table,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import ProfileRegistrationService from "./Locality/Service/profileRegistrationService"
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useContext, useEffect } from 'react';
import { useTheme } from "@material-ui/styles";
import {
  ResponsiveContainer,
  ComposedChart,
  AreaChart,
  LineChart,
  Line,
  Area,
  PieChart,
  Pie,
  Cell,
  YAxis,
  XAxis,
} from "recharts";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
// styles
import useStyles from "./styles";

// components
import mock from "./mock";
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";
import Dot from "../../components/Sidebar/components/Dot";
import BigStat from "./components/BigStat/BigStat";
import { withStyles } from '@material-ui/core/styles';
import CityServices from "../../services/CityServices";
export default function ProfileSRegistration(props) {
  const classes = useStyles();
  const [age, setAge] = React.useState('');

  var [error, setError] = useState(null);
  const [constituencyList, setConstituencyList] = useState([]);
  const [partyList, setPartyList] = useState([]);
  const [profileRegistrationList, setProfileRegistrationList] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [districtList, setDistrictList] = useState([]);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [cityList, setCityList] = useState([]);
  const [profileRegistration, setProfileRegistration] = useState({
    registrationType:'park',
    location: '',
    name: '',
    email: '',
    typeOfOrganization: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    contactPersonName:'',
    contactpersonDesignation:'',
    contactPersonEmail: '',
    mobileNumber1: '',
    mobileNumber2: '',
    password: '',
  });
  const handleChange = (event) => {
    setAge(event.target.value);
};
  const validationSchema = Yup.object().shape({
    location: Yup.string().required('location  is required'),
    registrationType:Yup.string().required('Registration Type  is required'),
    name: Yup.string().required('orgnaization name is required'),
    email: Yup.string().required('email is required'),
    typeOfOrganization: Yup.string(),
    addressLine1: Yup.string().required('Address Line 1 is required'),
    addressLine2: Yup.string(),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    country: Yup.string().required('Country is required'),
    pincode: Yup.string().required('Pincode is required')
      .matches(/^[0-9]+$/, 'Must be only digits')
      .min(5, 'Must be at least 5 digits')
      .max(10, 'Must be at most 10 digits'),
    contactPersonName: Yup.string().required('Name is required'),
    contactpersonDesignation: Yup.string(),
    contactPersonEmail: Yup.string().required('Contact person email is required')
      .email('Invalid email address'),
    mobileNumber1: Yup.string().required()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(10, 'Must be exactly 10 digits')
      .max(10, 'Must be exactly 10 digits'),
      mobileNumber2: Yup.string()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(10, 'Must be exactly 10 digits')
      .max(10, 'Must be exactly 10 digits'),
      password: Yup.string().required('password is required'),
  });
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

 

  const handleFormSubmit = (event) => {
    event.preventDefault();

  };
  const getProfileRegistrationList = () => {
    ProfileRegistrationService.getAllProfileRegistration().then((res) => {
      setProfileRegistrationList(res);
    }).catch((err) => {
      setError(err.message);
    });
  }
  const handleOpen = () => {
    setOpen(true);
  };
  useEffect(() => {
    CityServices.getAllCity().then((res) => {
      setCityList(res || []);
    }).catch(() => {});
    return () => {
    }
}, []);

  const formik = useFormik({
    initialValues: profileRegistration,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
        ProfileRegistrationService.creteProfileRegistration(values).then((res) => {

        alert(" Registration Successfully.");
         props.history.push('/sriqr/login');
      })
        .catch((err) => {
          alert(err.response.data.message)
        })
    },
  });


  return (

    <>
        <Grid item xs={12}>
          <Card sx={{ maxWidth: 345 }}>
            <Box   >
              
              <div style={{ marginLeft: "7%" }}>
                <form onSubmit={formik.handleSubmit} >
                
                  <Grid container spacing={2} columns={12} >
                    <Grid item xs={12}>
                      <PageTitle InputProps={{ style: { color: '#10b680' } }} title="Profile Registration" >aaaaa</PageTitle>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                    <FormControl>
      <FormLabel id="demo-row-radio-buttons-group-label">Select Registration Type</FormLabel>
      <RadioGroup
        row
        name="registrationType" 
        margin="dense"
      id="registrationType" 
       type="radio"
      variant="standard"
      value={formik.values.registrationType}
      onChange={formik.handleChange}
      error={formik.touched.registrationType && Boolean(formik.errors.registrationType)}
      helperText={formik.touched.registrationType && formik.errors.registrationType}
   
      >
        <FormControlLabel name="registrationType" value="park" control={<Radio />} label="Park" />
        <FormControlLabel name="registrationType" value="event" control={<Radio />} label="Event" />

        {/* <FormControlLabel name="registrationType" value="coaching" control={<Radio />} label="Coaching" /> */}
        <FormControlLabel name="registrationType" value="doctor" control={<Radio />} label="Doctor" />
        <FormControlLabel name="registrationType" value="loan" control={<Radio />} label="Loan" />
        <FormControlLabel name="registrationType" value="exbhition" control={<Radio />} label="Exhibition" />
      </RadioGroup>
    </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="name"
                        name="name"
                        label="Name of the business entity "
                        type="text"
                        variant="standard"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name && formik.errors.name}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="location"
                        name="location"
                        label="Location"
                        type="text"
                        variant="standard"
                        value={formik.values.location}
                        onChange={formik.handleChange}
                        error={formik.touched.location && Boolean(formik.errors.location)}
                        helperText={formik.touched.location && formik.errors.location}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="typeOfOrganization"
                        name="typeOfOrganization"
                        label="Type of Organization"
                        type="text"
                        variant="standard"
                        value={formik.values.typeOfOrganization}
                        onChange={formik.handleChange}
                        error={formik.touched.typeOfOrganization && Boolean(formik.errors.typeOfOrganization)}
                        helperText={formik.touched.typeOfOrganization && formik.errors.typeOfOrganization}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="addressLine1"
                        name="addressLine1"
                        label="Address Line 1"
                        type="text"
                        variant="standard"
                        value={formik.values.addressLine1}
                        onChange={formik.handleChange}
                        error={formik.touched.addressLine1 && Boolean(formik.errors.addressLine1)}
                        helperText={formik.touched.addressLine1 && formik.errors.addressLine1}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="addressLine2"
                        name="addressLine2"
                        label="Address Line 2"
                        type="text"
                        variant="standard"
                        value={formik.values.addressLine2}
                        onChange={formik.handleChange}
                        error={formik.touched.addressLine2 && Boolean(formik.errors.addressLine2)}
                        helperText={formik.touched.addressLine2 && formik.errors.addressLine2}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="city"
                        name="city"
                        label="City"
                        type="text"
                        variant="standard"
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        error={formik.touched.city && Boolean(formik.errors.city)}
                        helperText={formik.touched.city && formik.errors.city}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="state"
                        name="state"
                        label="State"
                        type="text"
                        variant="standard"
                        value={formik.values.state}
                        onChange={formik.handleChange}
                        error={formik.touched.state && Boolean(formik.errors.state)}
                        helperText={formik.touched.state && formik.errors.state}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <FormControl variant="standard">
                        <InputLabel id="country-label">Country</InputLabel>
                        <Select
                          labelId="country-label"
                          id="country"
                          name="country"
                          value={formik.values.country}
                          onChange={formik.handleChange}
                          error={formik.touched.country && Boolean(formik.errors.country)}
                          style={{ width: 370 }}
                        >
                          <MenuItem value=""><em>None</em></MenuItem>
                          <MenuItem value="India">India</MenuItem>
                          <MenuItem value="United States">United States</MenuItem>
                          <MenuItem value="United Kingdom">United Kingdom</MenuItem>
                          <MenuItem value="Canada">Canada</MenuItem>
                          <MenuItem value="Australia">Australia</MenuItem>
                          <MenuItem value="Germany">Germany</MenuItem>
                          <MenuItem value="France">France</MenuItem>
                          <MenuItem value="Japan">Japan</MenuItem>
                          <MenuItem value="China">China</MenuItem>
                          <MenuItem value="Brazil">Brazil</MenuItem>
                          <MenuItem value="Russia">Russia</MenuItem>
                          <MenuItem value="South Korea">South Korea</MenuItem>
                          <MenuItem value="Italy">Italy</MenuItem>
                          <MenuItem value="Spain">Spain</MenuItem>
                          <MenuItem value="Mexico">Mexico</MenuItem>
                          <MenuItem value="Indonesia">Indonesia</MenuItem>
                          <MenuItem value="Netherlands">Netherlands</MenuItem>
                          <MenuItem value="Saudi Arabia">Saudi Arabia</MenuItem>
                          <MenuItem value="Turkey">Turkey</MenuItem>
                          <MenuItem value="Switzerland">Switzerland</MenuItem>
                          <MenuItem value="Singapore">Singapore</MenuItem>
                          <MenuItem value="United Arab Emirates">United Arab Emirates</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                        </Select>
                        {formik.touched.country && formik.errors.country && (
                          <Typography variant="caption" color="error" style={{ marginLeft: 14, marginTop: 4 }}>
                            {formik.errors.country}
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="pincode"
                        name="pincode"
                        label="Pincode"
                        type="text"
                        variant="standard"
                        value={formik.values.pincode}
                        onChange={formik.handleChange}
                        error={formik.touched.pincode && Boolean(formik.errors.pincode)}
                        helperText={formik.touched.pincode && formik.errors.pincode}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="contactPersonName"
                        name="contactPersonName"
                        label="Contact Person Name"
                        type="text"
                        variant="standard"
                        value={formik.values.contactPersonName}
                        onChange={formik.handleChange}
                        error={formik.touched.contactPersonName && Boolean(formik.errors.contactPersonName)}
                        helperText={formik.touched.contactPersonName && formik.errors.contactPersonName}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="contactpersonDesignation"
                        name="contactpersonDesignation"
                        label="Designation"
                        type="text"
                        variant="standard"
                        value={formik.values.contactpersonDesignation}
                        onChange={formik.handleChange}
                        error={formik.touched.contactpersonDesignation && Boolean(formik.errors.contactpersonDesignation)}
                        helperText={formik.touched.contactpersonDesignation && formik.errors.contactpersonDesignation}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}

                        margin="dense"
                        id="mobileNumber1"
                        name="mobileNumber1"
                        label="Mobile Number-1"
                        type="text"
                        variant="standard"
                        value={formik.values.mobileNumber1}
                        onChange={formik.handleChange}
                        error={formik.touched.mobileNumber1 && Boolean(formik.errors.mobileNumber1)}
                        helperText={formik.touched.mobileNumber1 && formik.errors.mobileNumber1}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}

                        margin="dense"
                        id="mobileNumber2"
                        name="mobileNumber2"
                        label="Mobile Number-2"
                        type="text"
                        variant="standard"
                        value={formik.values.mobileNumber2}
                        onChange={formik.handleChange}
                        error={formik.touched.mobileNumber2 && Boolean(formik.errors.mobileNumber2)}
                        helperText={formik.touched.mobileNumber2 && formik.errors.mobileNumber2}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="email"
                        name="email"
                        label="Email ID "
                        type="Email ID"
                        variant="standard"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        InputProps={{ style: { width: 370 } }}
                        margin="dense"
                        id="contactPersonEmail"
                        name="contactPersonEmail"
                        label="Contact Person Email"
                        type="email"
                        variant="standard"
                        value={formik.values.contactPersonEmail}
                        onChange={formik.handleChange}
                        error={formik.touched.contactPersonEmail && Boolean(formik.errors.contactPersonEmail)}
                        helperText={formik.touched.contactPersonEmail && formik.errors.contactPersonEmail}
                      />
                    </Grid>
                  
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        id="password"
                        InputProps={{ style: { width: 370 } }}
                        margin="normal"
                        label="Password  "
                        // placeholder="Password"
                        type="password"
                        name="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        error={formik.touched.password && Boolean(formik.errors.password)}
                        helperText={formik.touched.password && formik.errors.password}
                      />
                    </Grid>
                  
                  </Grid>
                  <Grid item xs={6} style={{ textAlign: 'right', margin: '29px' }}>
                    <Button style={{ backgroundColor: '#ff6b81', color: 'white' }} type="submit" variant="contained" >Submit</Button>
                    </Grid>

                </form>
              </div>
            </Box>

          </Card>
       
      </Grid>
    </>
  );
}


